import $ from 'jquery';
import brandContainer from '@99designs/brand-container';
import relativeTime from '@99designs/brand-container/lib/ui/relative-time';
import Globalnav from '@99designs/globalnav';
import '@99designs/asimov/media-query-label';

// Fix https://www.cve.mitre.org/cgi-bin/cvename.cgi?name=2015-9251
// More: https://github.com/jquery/jquery/issues/2432
// Can be removed if upgrading to jQuery 3
jQuery.ajaxPrefilter((s) => { // eslint-disable-line no-undef
    s.contents.script = false; // eslint-disable-line no-param-reassign
});

// Initialise asimov-media-query-label outside dom
// ready check below. It has its own check and we want
// this to fire early on.
$(document).mediaQueryLabel();

$(() => {
    brandContainer();
    relativeTime.attachTo('html');

    const dataNode = document.getElementById('globalnav-data');
    const appNode = document.querySelector('[data-globalnav-notifications-dropdown]');

    // appNode only present for logged in users
    if (dataNode && appNode) {
        const { locale } = JSON.parse(dataNode.textContent);
        Globalnav(appNode, locale);
    }
});

// Send CSRF token with every AJAX request
// Adapted from https://github.com/rails/jquery-ujs
$.ajaxPrefilter((options, originalOptions, xhr) => {
    const token = $('meta[name="csrf-token"]').attr('content');
    if (token && !options.crossDomain) {
        xhr.setRequestHeader('X-CSRF-Token', token);
    }
});



// WEBPACK FOOTER //
// ./src/js/page/base.js